import { useLocation } from '@/lib/router-compat';
import { Helmet } from 'react-helmet-async';
import { SEOHreflang } from '@/components/seo/SEOHreflang';
import { useCanonicalUrl } from '@/hooks/useCanonicalUrl';
import { useCountry } from '@/hooks/useCountry';
import { routeLanguage } from '@/lib/seo/route-locale';

/**
 * AutoSEO component that automatically adds canonical URLs and hreflang
 * to ALL pages in the application. This component should be placed once
 * in the app root to ensure consistent SEO across all pages.
 */
export function AutoSEO() {
  const canonicalUrl = useCanonicalUrl();
  const location = useLocation();
  const { country } = useCountry();
  
  // Determine current language based on path
  const currentLang = routeLanguage(location.pathname);
  
  return (
    <>
      <Helmet>
        {/* Set HTML lang attribute dynamically */}
        <html lang={currentLang} />
        {/^(\/de|\/uk)(\/|$)/.test(location.pathname) && <meta name="robots" content="noindex,nofollow" />}
      </Helmet>

      {/* Hreflang tags for multi-country support */}
      <SEOHreflang canonicalUrl={canonicalUrl} />
    </>
  );

}
